"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiInvoiceRepo = createApiInvoiceRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const InvoiceMapper_1 = require("./mappers/InvoiceMapper");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
function createApiInvoiceRepo() {
    return {
        getById,
        update,
    };
}
async function getById(id) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v2/invoices/${id}`),
        });
        const product = (0, InvoiceMapper_1.mapToDomainInvoice)(res);
        (0, http_helpers_1.sendSuccessStatus)();
        return product;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return null;
    }
}
async function update(customer) {
    try {
        await HTTPClient_1.HTTPClient.put({
            url: (0, getApiUrl_1.getApiUrl)(`/v2/invoices/${customer.operationId}`),
            body: customer.customer,
            type: 'json',
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        throw error;
    }
}
